var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav__items"},_vm._l((_vm.data.GuiNodeCh),function(item){return _c('NavItem',{key:item.Xnodekey,attrs:{"data":item,"showIcon":_vm.showIcons,"activeNode":_vm.activeNode}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }